/**
 * US dollar display/parsing for spend caps and billing copy ($1,000.00).
 */

const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatUsdFromCents(cents) {
  if (cents == null || cents === '') return '—';
  const n = Number(cents);
  if (Number.isNaN(n)) return '—';
  return usd.format(n / 100);
}

export function formatUsdFromDollars(dollars) {
  if (dollars == null || dollars === '') return '—';
  const n = Number(dollars);
  if (Number.isNaN(n)) return '—';
  return usd.format(n);
}

/** Parse user-entered strings like "$1,000.00" or "1000" → dollars (float). */
export function parseUsdInputToDollars(raw) {
  if (raw == null || String(raw).trim() === '') return NaN;
  const s = String(raw).replace(/[$,\s]/g, '');
  if (s === '' || s === '.') return NaN;
  const n = parseFloat(s, 10);
  return Number.isNaN(n) ? NaN : n;
}
